export const getTextWithBrs = (text: string[], countBrs = 1): string => {
  let brs = ``

  for (let i = 1; i <= countBrs; i++) {
    brs += `</br>`
  }

  return text.reduce((str, txt, key, arr) => {
    if (arr.length - 1 === key) return `${str} ${txt}`

    return `${str} ${txt}${brs}`
  }, '')
}
